export default __webpack_public_path__ + "static/media/4.f7a172a0.jpg";